@if (viewModel) {
  <div class="popup">
    @for (item of viewModel.list; track item) {
      <p [innerHtml]="item.message"></p>
      @if (item.detail) {
        <p-fieldset legend="Dettagli" [toggleable]="true" [collapsed]="true">
          <p [innerHtml]="item.detail"></p>
        </p-fieldset>
      }
    }
  </div>
}
